module.exports = __webpack_public_path__ + "img/fourday_ps_04.9144cab5.jpg";